import { gql, useMutation } from "@apollo/client";
import {
  MediaFile,
  MutationUpdateMediaFileArgs,
} from "../../__generated__/types";

const UPDATE_MEDIA_FILE_MUTATION = gql`
  mutation UpdateMediaFile($_id: ID!, $title: String, $credit: String, $description: String) {
    updateMediaFile(_id: $_id, title: $title, credit: $credit, description: $description) {
      _id
      name
      path
      url
      userId
      title
      credit
      description
    }
  }
`;

export const useUpdateMediaFileMutation = () => {
  const [updateMediaFileMutation, { loading, error, data }] = useMutation(
    UPDATE_MEDIA_FILE_MUTATION
  );

  const updateMediaFile = async (
    args: MutationUpdateMediaFileArgs
  ): Promise<MediaFile> => {
    try {
      const result = await updateMediaFileMutation({
        variables: args,
      });
      return result?.data?.updateMediaFile;
    } catch (err) {
      console.error("Error updating media file:", err);
      throw err;
    }
  };

  return { updateMediaFile, loading, error, data };
};
